/**
 * Opens a URL in a new browser tab.
 *
 * @param url - The URL to open.
 */
export function openUrlInNewTab(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
}
